export const BUSINESS = {
  name: "Destination Roofing Inc.",
  shortName: "Destination Roofing",
  owner: "Deston Judy",
  phone: "(352) 901-3094",
  phoneE164: "+13529013094",
  phoneHref: "tel:+13529013094",
  email: "Destinationroofinginc@gmail.com",
  emailHref: "mailto:Destinationroofinginc@gmail.com",
  license: "License # CCC1335406",
  licenseNumber: "CCC1335406",
  serviceArea: "Serving Citrus County, FL and surrounding areas",
  offer: "Free Roof Inspection & Estimate",
  atlasCredential: "Atlas Certified Scotchgard™ Shingle Sales Specialist",
  facebook: "https://www.facebook.com/p/Destination-Roofing-Inc-61556805180586/?checkpoint_src=any",
  googleBusinessProfile: "https://share.google/LTcpMN4z1zl9WgF2W",
  hoursText: "Monday–Saturday: 6:30 AM–5:00 PM · Sunday: Closed",
  emergencyLine: "Roof emergency after normal business hours? Call (352) 901-3094. After-hours emergency response is available.",
};

// Verified Google Business Profile rating. Update here only.
export const GOOGLE_RATING = { rating: "5.0", count: 43 } as const;

export const SERVICES = [
  { slug: "/roof-replacement", title: "Roof Replacement", short: "Full tear-off and new roof installation." },
  { slug: "/roof-repair", title: "Roof Repair", short: "Leak repair, storm damage, missing shingles." },
  { slug: "/metal-roofing", title: "Metal Roofing", short: "Durable standing seam and metal panel systems." },
  { slug: "/shingle-roofing", title: "Shingle Roofing", short: "Architectural asphalt shingle installation." },
  { slug: "/flat-roofing", title: "Flat Roofing", short: "TPO, modified bitumen, and flat roof repair." },
  { slug: "/mobile-home-roofing", title: "Mobile Home Roofing", short: "Metal and TPO roof-overs, coatings, and leak repairs." },
  { slug: "/gutters", title: "Gutters", short: "Seamless gutter installation and repair." },
  { slug: "/soffit", title: "Soffit", short: "Soffit and fascia repair and replacement." },
  { slug: "/third-nail-wind-mitigation", title: "Third Nail Wind Mitigation", short: "Ask whether eligible wind-mitigation improvements may help you qualify for insurance credits." },
  { slug: "/roof-inspection", title: "Roof Inspection", short: "Honest, no-pressure roof inspection with a written estimate." },
  { slug: "/storm-damage-roof-repair", title: "Storm Damage Roof Repair", short: "Wind, hail and storm-damage roof inspection and repair." },
  { slug: "/commercial-roofing", title: "Commercial Roofing", short: "Commercial roof repair, replacement and low-slope systems." },
] as const;

export const CITIES = [
  { slug: "/roofing-company-beverly-hills-fl", city: "Beverly Hills", state: "FL" },
  { slug: "/roofing-company-inverness-fl", city: "Inverness", state: "FL" },
  { slug: "/roofing-company-crystal-river-fl", city: "Crystal River", state: "FL" },
  { slug: "/roofing-company-homosassa-fl", city: "Homosassa", state: "FL" },
  { slug: "/roofing-company-lecanto-fl", city: "Lecanto", state: "FL" },
  { slug: "/roofing-company-hernando-fl", city: "Hernando", state: "FL" },
  { slug: "/roofing-company-floral-city-fl", city: "Floral City", state: "FL" },
  { slug: "/roofing-company-citrus-springs-fl", city: "Citrus Springs", state: "FL" },
  { slug: "/roofing-company-dunnellon-fl", city: "Dunnellon", state: "FL" },
  { slug: "/roofing-company-spring-hill-fl", city: "Spring Hill", state: "FL" },
  { slug: "/roofing-company-citrus-hills-fl", city: "Citrus Hills", state: "FL" },
  { slug: "/roofing-company-pine-ridge-fl", city: "Pine Ridge", state: "FL" },
] as const;

export const BLOG_POSTS = [
  {
    slug: "/blog/signs-roof-needs-repair-citrus-county",
    title: "Signs Your Citrus County Roof May Need Repair After a Storm",
    seoTitle: "Signs Your Citrus County Roof Needs Repair After a Storm",
    excerpt: "Working as a roofer in Citrus County and Spring Hill, I inspect roofs in just about every condition. Here are the warning signs to catch roof damage early.",
    description: "Learn warning signs of roof damage after heavy rain, hail and high winds in Citrus County, Beverly Hills, Crystal River and nearby areas.",
    datePublished: "2026-07-16",
    dateModified: "2026-07-16",
    articleSection: "Roof Damage",
  },
  {
    slug: "/blog/shingle-metal-flat-roofing-citrus-county",
    title: "Shingle, Metal or Flat Roofing: Which Roof Is Right for Your Florida Home?",
    seoTitle: "Shingle vs. Metal vs. Flat Roofing in Citrus County",
    excerpt: "The best roofing material depends less on the neighborhood and more on the home's structure, roof slope, budget and long-term goals. Here's how to decide.",
    description: "Compare shingle, metal and flat roofing to determine the right roof installation for your Citrus County home.",
    datePublished: "2026-07-16",
    dateModified: "2026-07-16",
    articleSection: "Roofing Materials",
  },
  {
    slug: "/blog/attic-venting-soffits-gutters-roof-system",
    title: "Your Roof Is a Complete System: Attic Venting, Soffits, Gutters and Wind Mitigation",
    seoTitle: "How Attic Venting, Soffits and Gutters Protect Your Roof",
    excerpt: "A roof is not just a layer of shingles. Attic venting, soffits, gutters and roof-to-wall connections all work together to protect your Florida home.",
    description: "Learn how attic venting, soffits, gutters, skylights and third-nail wind mitigation protect Florida roofs from moisture and storm damage.",
    datePublished: "2026-07-16",
    dateModified: "2026-07-16",
    articleSection: "Roof System",
  },
] as const;
